import { useQuery } from "@apollo/client";
import { GET_ACKNOWLEDGED_CONTENT } from "graphql/queries";

export default options => {
  const { data, loading, error } = useQuery(GET_ACKNOWLEDGED_CONTENT, options);

  return [data?.me || {}, loading, error];
};
